import _objectWithoutProperties from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["grantType"],
      _excluded2 = ["feedbackUuid", "accessChannel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isNil, omitBy } from 'lodash';
import { transformBrowserAttributesModel } from 'data/transformers/browser-attributes';
import { transformCreditCardEncryptedModel } from 'data/transformers/credit-card-encrypted';
import { transformBusinessAccountAddressModel } from 'data/transformers/business-account';
import { AddressEntryType } from 'constants/address';
import { IntellectualPropertyCategory, RightsToOrganization } from 'constants/intellectual-property-infringement';
import { getItemsInText } from 'pages/HelpCenter/IntellectualPropertyInfringement/utils';

const getSelectedDynamicFiltersArgs = selectedDynamicFilters => {
  if (!selectedDynamicFilters) return {};
  const dynamicParams = {};
  selectedDynamicFilters.forEach(_ref => {
    let {
      type,
      ids
    } = _ref;
    dynamicParams["".concat(type, "_ids")] = ids.join(',');
  });
  return dynamicParams;
};

const transformCatalogFiltersModelToParams = _ref2 => {
  let {
    query,
    catalogIds,
    priceFrom,
    priceTo,
    currency,
    colorIds,
    brandIds,
    sizeIds,
    materialIds,
    videoGameRatingIds,
    statusIds,
    sortBy,
    isPopularCatalog,
    catalogFrom,
    disableSearchSaving
  } = _ref2;
  return {
    search_text: query,
    catalog_ids: catalogIds === null || catalogIds === void 0 ? void 0 : catalogIds.join(','),
    price_from: priceFrom,
    price_to: priceTo,
    currency,
    color_ids: colorIds === null || colorIds === void 0 ? void 0 : colorIds.join(','),
    brand_ids: brandIds === null || brandIds === void 0 ? void 0 : brandIds.join(','),
    size_ids: sizeIds === null || sizeIds === void 0 ? void 0 : sizeIds.join(','),
    material_ids: materialIds === null || materialIds === void 0 ? void 0 : materialIds.join(','),
    video_game_rating_ids: videoGameRatingIds === null || videoGameRatingIds === void 0 ? void 0 : videoGameRatingIds.join(','),
    status_ids: statusIds === null || statusIds === void 0 ? void 0 : statusIds.join(','),
    order: sortBy,
    popular: isPopularCatalog || null,
    catalog_from: catalogFrom,
    disable_search_saving: disableSearchSaving
  };
};

export const getClosetPromotionsArgsToParams = args => {
  var _args$excludedUserIds;

  const staticArgs = _objectSpread({
    page: args.page,
    per_page: args.perPage,
    item_count: args.itemCount,
    exclude_member_ids: (_args$excludedUserIds = args.excludedUserIds) === null || _args$excludedUserIds === void 0 ? void 0 : _args$excludedUserIds.join(','),
    feed_items_only: args.feedItemsOnly,
    search_session_id: args.searchSessionId,
    screen_name: args.screenName
  }, transformCatalogFiltersModelToParams(args));

  return omitBy(_objectSpread(_objectSpread({}, staticArgs), getSelectedDynamicFiltersArgs(args.selectedDynamicFilters)), isNil);
};
export const getCatalogItemsArgsToParams = args => {
  const staticArgs = _objectSpread({
    page: args.page,
    per_page: args.perPage,
    time: args.time,
    search_session_id: args.searchSessionId,
    global_search_session_id: args.globalSearchSessionId || null
  }, transformCatalogFiltersModelToParams(args));

  return omitBy(_objectSpread(_objectSpread({}, staticArgs), getSelectedDynamicFiltersArgs(args.selectedDynamicFilters)), isNil);
};
export const getCatalogFiltersArgsToParams = _ref3 => {
  let {
    query,
    catalogIds,
    priceFrom,
    priceTo,
    currency,
    colorIds,
    brandIds,
    sizeIds,
    materialIds,
    videoGameRatingIds,
    statusIds,
    sortBy,
    time,
    isPopularCatalog,
    catalogFrom,
    selectedDynamicFilters,
    supportedFilters,
    filterSearchCode,
    filterSearchText
  } = _ref3;
  const staticArgs = {
    search_text: query,
    catalog_ids: catalogIds.join(','),
    price_from: priceFrom,
    price_to: priceTo,
    currency,
    color_ids: colorIds.join(','),
    brand_ids: brandIds.join(','),
    size_ids: sizeIds.join(','),
    material_ids: materialIds.join(','),
    video_game_rating_ids: videoGameRatingIds.join(','),
    status_ids: statusIds.join(','),
    order: sortBy,
    time,
    popular: isPopularCatalog || null,
    catalog_from: catalogFrom,
    supported_filters: supportedFilters.join(','),
    filter_search_code: filterSearchCode,
    filter_search_text: filterSearchText
  };
  return omitBy(_objectSpread(_objectSpread({}, staticArgs), getSelectedDynamicFiltersArgs(selectedDynamicFilters)), isNil);
};
export const getCatalogSearchedFiltersArgsToParams = _ref4 => {
  let {
    filterSearchCode,
    filterSearchText,
    query,
    catalogIds,
    priceFrom,
    priceTo,
    currency,
    colorIds,
    brandIds,
    sizeIds,
    materialIds,
    videoGameRatingIds,
    statusIds,
    sortBy,
    isPopularCatalog,
    catalogFrom,
    selectedDynamicFilters
  } = _ref4;
  const staticArgs = {
    filter_search_code: filterSearchCode,
    filter_search_text: filterSearchText,
    search_text: query,
    catalog_ids: catalogIds.join(','),
    price_from: priceFrom,
    price_to: priceTo,
    currency,
    color_ids: colorIds.join(','),
    brand_ids: brandIds.join(','),
    size_ids: sizeIds.join(','),
    material_ids: materialIds.join(','),
    video_game_rating_ids: videoGameRatingIds.join(','),
    status_ids: statusIds.join(','),
    order: sortBy,
    popular: isPopularCatalog || null,
    catalog_from: catalogFrom
  };
  return omitBy(_objectSpread(_objectSpread({}, staticArgs), getSelectedDynamicFiltersArgs(selectedDynamicFilters)), isNil);
};
export const getCatalogDefaultFiltersArgsToParams = _ref5 => {
  let {
    catalogIds
  } = _ref5;
  return {
    catalog_ids: catalogIds.join(',')
  };
};
export const getUserItemsArgsToParams = _ref6 => {
  let {
    currentPage,
    perPage,
    order,
    filter,
    catalogIds
  } = _ref6;
  return {
    page: currentPage + 1,
    per_page: perPage,
    cond: filter,
    order,
    catalog_ids: catalogIds === null || catalogIds === void 0 ? void 0 : catalogIds.join(',')
  };
};
export const createPaymentsAccountArgsToParams = args => {
  return {
    payments_account: {
      user_address_id: args.addressId,
      first_name: args.firstName || undefined,
      last_name: args.lastName || undefined,
      birthdate: args.birthdate || undefined,
      ssn_serial: args.ssnNumber || undefined,
      personal_id_number: args.personalIdNumber || undefined,
      nationality: args.nationality ? {
        code: args.nationality.code
      } : undefined
    }
  };
};
export const createPayoutArgsToParams = _ref7 => {
  let {
    userId,
    bankAccountId,
    amount,
    currency
  } = _ref7;
  return {
    payout: {
      seller_id: userId,
      bank_account_id: bankAccountId,
      amount,
      currency
    }
  };
};
export const addUserAddressArgsToParams = _ref8 => {
  let {
    address
  } = _ref8;
  return {
    entry_type: address.entryType,
    country_id: address.countryId,
    name: address.name,
    country: address.country,
    city: address.city,
    line1: address.line1,
    line2: address.line2,
    postal_code: address.postalCode
  };
};
export const addShippingAddressArgsToParams = _ref9 => {
  let {
    address
  } = _ref9;
  return {
    entry_type: AddressEntryType.Shipping,
    country_id: address.countryId,
    name: address.name,
    country: address.country,
    city: address.city,
    line1: address.line1,
    line2: address.line2,
    postal_code: address.postalCode
  };
};
export const updateCurrentUserSettingsArgsToParams = _ref10 => {
  let {
    isNewsletterSubscribed,
    allowMyFavouriteNotifications,
    isLocationPublic,
    isPublishPhotosAgreed,
    thirdPartyTracking,
    allowPersonalization
  } = _ref10;
  return {
    is_newsletter_subscriber: isNewsletterSubscribed,
    allow_my_favourite_notifications: allowMyFavouriteNotifications,
    is_location_public: isLocationPublic,
    is_publish_photos_agreed: isPublishPhotosAgreed,
    third_party_tracking: thirdPartyTracking,
    allow_personalization: allowPersonalization
  };
};
export const updateBusinessAccountProfileDetailsArgsToParams = _ref11 => {
  let {
    username,
    contactEmail,
    contactNumber,
    vat,
    about,
    photoTempUuid
  } = _ref11;
  return {
    name: username,
    email: contactEmail,
    phone_number: contactNumber,
    text_about: about,
    photo_temp_uuid: photoTempUuid,
    vat
  };
};
export const updateCurrentUserArgsToParams = _ref12 => {
  let {
    realName,
    cityId,
    countryId,
    gender,
    birthday,
    about,
    username,
    photoTempUuid,
    isCityVisible,
    isOnHoliday,
    isInternationalTradingEnabled,
    fingerprint
  } = _ref12;
  return {
    user: {
      real_name: realName,
      city_id: cityId,
      country_id: countryId,
      gender,
      birthday,
      text_about: about,
      login: username,
      photo_temp_uuid: photoTempUuid,
      user_settings: {
        is_location_public: isCityVisible,
        on_holiday: isOnHoliday,
        international_trading_enabled: isInternationalTradingEnabled
      }
    },
    fingerprint
  };
};
export const getNearbyShipmentOptionsArgsToParams = _ref13 => {
  let {
    countryCode,
    latitude,
    longitude,
    addressLine,
    postalCode,
    city,
    limit,
    shouldLabelNearestPoints
  } = _ref13;
  return omitBy({
    country_code: countryCode,
    latitude,
    longitude,
    address_line: addressLine,
    postal_code: postalCode,
    city,
    limit,
    should_label_nearest_points: shouldLabelNearestPoints
  }, isNil);
};
export const addBankAccountArgsToParams = _ref14 => {
  let {
    name,
    accountNumber,
    routingNumber,
    addressId,
    externalCode,
    spendingType
  } = _ref14;
  return {
    name,
    user_address_id: addressId,
    account_number: accountNumber,
    routing_number: routingNumber,
    external_code: externalCode,
    spending_type: spendingType
  };
};
export const updateExtraServicePaymentArgsToParams = _ref15 => {
  let {
    paymentData
  } = _ref15;
  return {
    payment_data: _objectSpread({}, paymentData)
  };
};
export const confirmExtraServiceOrderArgsToParams = _ref16 => {
  let {
    orderId,
    blikCode,
    orderType,
    entityType,
    creditCardId,
    paymentMethodId,
    browserAttributes
  } = _ref16;
  return {
    order_id: orderId,
    blik_code: blikCode,
    order_type: orderType,
    external_card_code: creditCardId,
    payment_method_id: paymentMethodId,
    browser_attributes: browserAttributes ? transformBrowserAttributesModel(browserAttributes) : undefined,
    redirect_params: entityType && {
      entity_type: entityType
    }
  };
};
export const updateCheckoutDataArgsToParams = _ref17 => {
  let {
    toAddressId,
    deliveryType,
    creditCardId,
    packageTypeId,
    payInMethodId,
    pickupPointCode,
    rateUuid,
    isOfflineVerificationEnabled,
    pointUuid,
    rootRateUuid
  } = _ref17;
  return {
    transaction: {
      shipment: {
        to_address_id: toAddressId,
        delivery_type: deliveryType,
        package_type_id: packageTypeId,
        pickup_point_code: pickupPointCode,
        rate_uuid: rateUuid,
        point_uuid: pointUuid,
        root_rate_uuid: rootRateUuid
      },
      buyer_debit: {
        pay_in_method_id: payInMethodId,
        external_card_code: creditCardId
      },
      offline_verification: {
        enabled: isOfflineVerificationEnabled
      }
    }
  };
};
export const escrowPaymentInitiationArgsToParams = _ref18 => {
  let {
    blikCode,
    isSingleUse,
    browserAttributes,
    transactionChecksum
  } = _ref18;
  return {
    blik_code: blikCode,
    single_use_card: isSingleUse,
    checksum: transactionChecksum,
    browser_attributes: transformBrowserAttributesModel(browserAttributes)
  };
};
export const escrowPaymentDataUpdateArgsToParams = _ref19 => {
  let {
    paymentData
  } = _ref19;
  return {
    payment_data: _objectSpread({}, paymentData)
  };
};
export const sendHelpCenterFeedbackArgsToParams = _ref20 => {
  let {
    expirationDate,
    ticketId,
    rating,
    effort,
    comment,
    digest
  } = _ref20;
  return {
    helpdesk_feedback: {
      ticket_id: ticketId,
      rating,
      effort,
      comment
    },
    expiration_date: expirationDate,
    digest
  };
};
export const sendItemUploadFeedbackArgsToParams = _ref21 => {
  let {
    rating,
    comment,
    finalized,
    itemId,
    feedbackStatementIds
  } = _ref21;
  return {
    item_id: itemId,
    rating,
    comment,
    finalized,
    feedback_statement_ids: feedbackStatementIds
  };
};
export const updateFeedbackRatingOptionsArgsToParams = _ref22 => {
  let {
    rating,
    message,
    feedbackStatementParentId,
    feedbackStatementIds,
    finalized
  } = _ref22;
  return {
    feedback_ratings: {
      finalized,
      rating,
      comment: message,
      feedback_statement_parent_id: feedbackStatementParentId,
      feedback_statement_ids: feedbackStatementIds
    }
  };
};

const addressToParams = address => address && {
  country_id: address.countryId,
  name: address.name || null,
  city: address.city || null,
  line1: address.line1 || null,
  line2: address.line2 || null,
  postal_code: address.postalCode || null
} || null;

const documentFileToParams = file => ({
  type: file.type,
  files: file.files.map(_ref23 => {
    let {
      identifier,
      body,
      mediaType
    } = _ref23;
    return {
      identifier,
      body,
      media_type: mediaType
    };
  })
});

export const submitPaymentsIdentityArgsToParams = _ref24 => {
  let {
    firstName,
    lastName,
    birthdate,
    ssnSerial,
    personalIdNumber,
    address,
    ubos,
    documents
  } = _ref24;
  const transformedDocuments = (documents === null || documents === void 0 ? void 0 : documents.map(document => documentFileToParams(document))) || [];
  return {
    first_name: firstName,
    last_name: lastName,
    birthdate,
    ssn_serial: ssnSerial,
    personal_id_number: personalIdNumber,
    address: addressToParams(address),
    ubos: (ubos === null || ubos === void 0 ? void 0 : ubos.map(ubo => ({
      first_name: ubo.firstName,
      last_name: ubo.lastName,
      birthday: ubo.birthday,
      nationality: ubo.nationality,
      birthplace_city: ubo.birthplaceCity,
      birthplace_country: ubo.birthplaceCountry,
      address: addressToParams(ubo.address)
    }))) || null,
    documents: transformedDocuments
  };
};
export const setBusinessAccountPoliciesArgsToParams = _ref25 => {
  let {
    termsAndConditions,
    returnPolicy,
    additionalInformation
  } = _ref25;
  return {
    terms_and_conditions: termsAndConditions,
    return_policy: returnPolicy,
    additional_information: additionalInformation
  };
};
export const setBusinessAccountAddressesArgsToParams = _ref26 => {
  let {
    businessAddress,
    returnAddress
  } = _ref26;
  return {
    business_address: businessAddress && transformBusinessAccountAddressModel(businessAddress),
    return_address: returnAddress && transformBusinessAccountAddressModel(returnAddress)
  };
};
export const registerCreditCardArgsToParams = _ref27 => {
  let {
    id,
    brand,
    registrationData,
    encryptedCardDetails,
    isSingleUse,
    browserAttributes,
    source
  } = _ref27;
  return {
    browser_attributes: transformBrowserAttributesModel(browserAttributes),
    credit_card_registration: {
      id,
      registration_data: registrationData,
      encrypted_card_details: encryptedCardDetails ? transformCreditCardEncryptedModel(encryptedCardDetails) : undefined
    },
    credit_card: {
      brand,
      single_use: isSingleUse
    },
    redirect_params: {
      order_id: source.orderId,
      entity_id: source.entityId,
      entity_type: source.entityType
    }
  };
};
export const authenticateCreditCardArgsToParams = _ref28 => {
  let {
    paymentData,
    registrationId
  } = _ref28;
  return {
    credit_card_registration: {
      id: registrationId
    },
    payment_data: _objectSpread({}, paymentData)
  };
};
export const getCreateSupportTicketArgs = _ref29 => {
  let {
    faqEntryId,
    ch,
    problemTextId,
    transactionId,
    threadId,
    tempUuid,
    message,
    isEnglishAllowed,
    itemId,
    memberId,
    email
  } = _ref29;
  return {
    faq_entry_id: faqEntryId,
    ch,
    transaction_id: transactionId,
    thread_id: threadId,
    problem_text_id: problemTextId,
    temp_uuid: tempUuid,
    help_contact_form: {
      message,
      english_allowed: isEnglishAllowed,
      item_id: itemId,
      transaction_id: transactionId,
      member_id: memberId,
      email
    }
  };
};
export const createAdminAlertArgsToParams = _ref30 => {
  let {
    adminAlert: {
      refType,
      reportReasonId,
      refId,
      message,
      options
    }
  } = _ref30;

  const getOptionParams = () => {
    return omitBy({
      reported_message_id: options === null || options === void 0 ? void 0 : options.reportedMessageId,
      reported_photo_id: options === null || options === void 0 ? void 0 : options.reportedPhotoId
    }, isNil);
  };

  return {
    admin_alert: omitBy({
      ref_type: refType,
      ref_id: refId,
      report_reason_id: reportReasonId,
      message,
      options: options ? getOptionParams() : undefined
    }, isNil)
  };
};
export const authenticateUserArgsToParams = _ref31 => {
  let {
    grantType
  } = _ref31,
      loginUserArgs = _objectWithoutProperties(_ref31, _excluded);

  if ('verificationCode' in loginUserArgs) {
    return {
      control_code: loginUserArgs.controlCode,
      password_type: loginUserArgs.passwordType,
      verification_code: loginUserArgs.verificationCode,
      grant_type: grantType,
      is_trusted_device: loginUserArgs.isTrustedDevice
    };
  }

  if ('controlCode' in loginUserArgs) {
    return {
      control_code: loginUserArgs.controlCode,
      grant_type: grantType,
      username: loginUserArgs.username,
      password: loginUserArgs.password,
      fingerprint: loginUserArgs.fingerprint
    };
  }

  const args = Object.assign({}, loginUserArgs);
  return _objectSpread(_objectSpread({}, args), {}, {
    grant_type: grantType
  });
};

const getContactDetails = _ref32 => {
  let {
    rightsToOrganization,
    firstName,
    lastName,
    email,
    company,
    address,
    city,
    worldCountry,
    postalCode
  } = _ref32;

  switch (rightsToOrganization === null || rightsToOrganization === void 0 ? void 0 : rightsToOrganization.value) {
    case RightsToOrganization.Owner:
    case RightsToOrganization.Agent:
    case RightsToOrganization.Lawyer:
    case RightsToOrganization.IpOwner:
    case RightsToOrganization.IpAgent:
    case RightsToOrganization.IpLawyer:
    case RightsToOrganization.Organization:
    case RightsToOrganization.TrustedFlagger:
      return {
        first_name: firstName,
        last_name: lastName,
        email,
        company,
        address,
        city,
        country_code: worldCountry === null || worldCountry === void 0 ? void 0 : worldCountry.code,
        zip_code: postalCode
      };

    case RightsToOrganization.Individual:
      return {
        first_name: firstName,
        last_name: lastName,
        email
      };

    default:
      return {};
  }
};

const getIpInfringementParams = _ref33 => {
  let {
    intellectualPropertyCategory,
    rightsConsistOf,
    intellectualPropertyOwner,
    intellectualPropertyName,
    registrationNumber,
    proofOfRights,
    brand,
    description,
    attachments,
    infringingUrlsTextArea
  } = _ref33;

  const getCategoryDependantFields = () => {
    if (intellectualPropertyCategory === IntellectualPropertyCategory.Other) {
      return {
        rights_consist_of: rightsConsistOf
      };
    }

    return {
      owner: intellectualPropertyOwner,
      name: intellectualPropertyName,
      registration_number: registrationNumber
    };
  };

  const illegalContentUrls = getItemsInText(infringingUrlsTextArea).map(url => ({
    url
  }));
  return _objectSpread(_objectSpread({
    category: intellectualPropertyCategory
  }, getCategoryDependantFields()), {}, {
    proof_of_rights: proofOfRights,
    brand: brand === null || brand === void 0 ? void 0 : brand.title,
    description,
    attachments: attachments === null || attachments === void 0 ? void 0 : attachments.map(attachment => ({
      temp_uuid: attachment.id
    })),
    illegal_contents: illegalContentUrls
  });
};

const getGenericReportParams = _ref34 => {
  let {
    illegalContentType,
    reportReasonType,
    description,
    infringingUrlsTextArea,
    attachments
  } = _ref34;
  return {
    illegal_content_type: illegalContentType,
    report_reason_code: reportReasonType,
    description,
    illegal_contents: getItemsInText(infringingUrlsTextArea).map(url => ({
      url
    })),
    attachments: attachments === null || attachments === void 0 ? void 0 : attachments.map(attachment => ({
      temp_uuid: attachment.id
    }))
  };
};

const getPropertyRightsParams = form => {
  var _form$rightsToOrganiz;

  switch ((_form$rightsToOrganiz = form.rightsToOrganization) === null || _form$rightsToOrganiz === void 0 ? void 0 : _form$rightsToOrganiz.value) {
    case RightsToOrganization.Owner:
    case RightsToOrganization.Agent:
    case RightsToOrganization.Lawyer:
    case RightsToOrganization.IpOwner:
    case RightsToOrganization.IpAgent:
    case RightsToOrganization.IpLawyer:
      return getIpInfringementParams(form);

    case RightsToOrganization.Individual:
    case RightsToOrganization.Organization:
    case RightsToOrganization.TrustedFlagger:
      return getGenericReportParams(form);

    default:
      return {};
  }
};

export const sendIntellectualPropertyInfringementArgsToParams = (form, captchaToken) => {
  var _form$rightsToOrganiz2;

  return {
    rights_to_organization: (_form$rightsToOrganiz2 = form.rightsToOrganization) === null || _form$rightsToOrganiz2 === void 0 ? void 0 : _form$rightsToOrganiz2.value,
    contacts: getContactDetails(form),
    property_rights: getPropertyRightsParams(form),
    captcha_token: captchaToken
  };
};
export const createDirectDonationOrderArgsToParams = _ref35 => {
  let {
    charityCode,
    amount,
    currencyCode
  } = _ref35;
  return {
    charity_code: charityCode,
    contribution: {
      amount,
      currency_code: currencyCode
    }
  };
};
export const updateFaqEntryFeedbackArgsToParams = _ref36 => {
  let {
    feedbackUuid,
    accessChannel
  } = _ref36,
      feedbackRatings = _objectWithoutProperties(_ref36, _excluded2);

  return _objectSpread({
    feedback_uuid: feedbackUuid,
    access_channel: accessChannel
  }, updateFeedbackRatingOptionsArgsToParams(feedbackRatings));
};
export const updateShippingDateArgsToParams = _ref37 => {
  let {
    shippingDate
  } = _ref37;
  return {
    shipping_date: shippingDate
  };
};
export const updateUserBundleDiscountsArgsToParams = _ref38 => {
  let {
    isEnabled,
    discounts
  } = _ref38;
  return {
    bundle_discount: {
      enabled: isEnabled,
      discounts: discounts === null || discounts === void 0 ? void 0 : discounts.map(_ref39 => {
        let {
          fraction,
          minimalItemCount
        } = _ref39;
        return {
          fraction,
          minimal_item_count: minimalItemCount
        };
      })
    }
  };
};
export const getVasGalleryArgsToParams = _ref40 => {
  let {
    query,
    catalogIds,
    colorIds,
    brandIds,
    sizeIds,
    materialIds,
    videoGameRatingIds,
    statusIds
  } = _ref40;
  return {
    search_text: query,
    catalog_ids: catalogIds === null || catalogIds === void 0 ? void 0 : catalogIds.join(','),
    color_ids: colorIds === null || colorIds === void 0 ? void 0 : colorIds.join(','),
    brand_ids: brandIds === null || brandIds === void 0 ? void 0 : brandIds.join(','),
    size_ids: sizeIds === null || sizeIds === void 0 ? void 0 : sizeIds.join(','),
    material_ids: materialIds === null || materialIds === void 0 ? void 0 : materialIds.join(','),
    video_game_rating_ids: videoGameRatingIds === null || videoGameRatingIds === void 0 ? void 0 : videoGameRatingIds.join(','),
    status_ids: statusIds === null || statusIds === void 0 ? void 0 : statusIds.join(',')
  };
};
export const getDynamicAttributesArgsToParams = _ref41 => {
  let {
    catalogId
  } = _ref41;
  return {
    catalog_id: catalogId
  };
};
export const updateTaxpayerFormDataArgsToParams = _ref42 => {
  let {
    countryOfTaxResidency,
    firstName,
    lastName,
    birthdate,
    billingAddressId,
    taxIdentificationNumber,
    birthplaceCountry,
    birthplaceCity,
    businessName,
    businessCode,
    secondaryBusinessCode,
    vatNumber,
    businessAddressId,
    businessEstablishmentCountries
  } = _ref42;
  return {
    taxpayer: {
      first_name: firstName,
      last_name: lastName,
      birthdate,
      country_of_tax_residency: countryOfTaxResidency,
      tin: taxIdentificationNumber,
      billing_address_id: billingAddressId,
      birthplace_country: birthplaceCountry,
      birthplace_city: birthplaceCity,
      business_name: businessName,
      business_code: businessCode,
      secondary_business_code: secondaryBusinessCode,
      vat_number: vatNumber,
      business_address_id: businessAddressId,
      business_establishment_countries: businessEstablishmentCountries
    }
  };
};
export const addNearbyDropOffPointArgsToParams = _ref43 => {
  let {
    countryCode,
    latitude,
    longitude
  } = _ref43;
  return {
    country_code: countryCode,
    latitude,
    longitude
  };
};
export const getCreateAppealArgs = _ref44 => {
  let {
    threadId,
    message,
    attachments
  } = _ref44;
  return {
    thread_id: threadId,
    message,
    attachments
  };
};
export const getAvailableUserItemsForCollectionArgsToParams = _ref45 => {
  let {
    currentPage,
    perPage,
    order,
    catalogIds
  } = _ref45;
  return {
    page: currentPage + 1,
    per_page: perPage,
    order,
    catalog_ids: catalogIds === null || catalogIds === void 0 ? void 0 : catalogIds.join(',')
  };
};